// removed by extract-text-webpack-plugin
module.exports = {"BreakpointToMedium":"(max-width: 639px)","BreakpointToSmall":"(max-width: 374px)","tableSection":"G27f590","tableContent":"Ge0b1a2"};